import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'
import mapboxgl from 'mapbox-gl'
import { Location } from 'src/types/schema/graphql'
import { useRouter } from 'next/router'
import { mapStyle } from '../../util/constants'
interface ICard {
    location: Location
}

const LocationCard: React.FC<ICard> = ({ location }) => {
    const router = useRouter()
    const mapContainer = React.useRef(null)
    const [map, setMap] = React.useState<mapboxgl.Map | null>(null)
    const accessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN

    const handleClick = () =>
        router.push({
            pathname: '/brewer/[brewerSlug]/locations/[locationSlug]',
            query: { brewerSlug: location?.brand?.slug, locationSlug: location?.slug },
        })
    React.useEffect(() => {
        if (mapContainer?.current && !map) {
            const map = new mapboxgl.Map({
                container: mapContainer.current,
                style: mapStyle,
                zoom: 14,
                accessToken,
                interactive: false,
                center: [location?.address?.geo?.lon, location?.address?.geo?.lat],
            })
            setMap(map)
            const markerEl = document.createElement('div')
            markerEl.className = 'marker flex items-center justify-center'
            markerEl.style.backgroundImage = `url('../../assets/Marker-Green-Icon.png')`
            markerEl.style.width = '63px'
            markerEl.style.height = '70px'
            markerEl.style.backgroundSize = '100%'
            new mapboxgl.Marker(markerEl)
                .setLngLat([location?.address?.geo?.lon, location?.address?.geo?.lat])
                .addTo(map)
        }

        return () => {
            map?.remove()
        }
    }, [mapContainer.current])

    return (
        <UI.Card
            format='default'
            onClick={handleClick}
            item={{
                subtitle: (
                    <div className='flex items-center gap-x-1'>
                        <UI.Icon size='sm' slug='HeroIcons.LocationMarker' />
                        <p className='space-x-1 font-normal'>
                            <span>{location?.address?.street}</span>,
                            <span>{location?.address?.city}</span>,
                            <span>{location?.address?.state}</span>
                        </p>
                    </div>
                ),
                title: location?.title,
            }}
            customClasses='flex-shrink-0  w-5/6 md:w-9/12   lg:w-[385px] hover:bg-gray-50 hover:border-transparent fade-2 duration-150 ease cursor-pointer'
            banner={<div ref={mapContainer} className=' w-82 relative h-48' />}
        />
    )
}

export default LocationCard
